import { createContext, useContext } from "react";
import { CompanyPlaidAccounts } from "../../types/CompanyPlaidAccounts";

export type AccountContextValues = {
  accounts: CompanyPlaidAccounts[];
  total: number;
  loadingStatus: string;
  isValidating: boolean;
  refetch: () => void;
  error: any;
};

export const AccountContext = createContext<AccountContextValues>({
  accounts: [],
  total: 0,
  loadingStatus: "initial",
  isValidating: false,
  refetch: () => {},
  error: null,
});

export const useAccountContext = () => useContext(AccountContext);
